import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function OneRuleDialReturnButtons(props: any) {

    const {dialRule, setDialRule} = props

    const tmplItems: any = ['value', 'name', 'unit', 'loc-value']

    const itemStyle: any = {
        color: 'grey',
        fontFamily: "'Inter', sans-serif",
        fontSize: "0.68rem",
        cursor: "pointer",
    }

    const tmplItemsGridStyle: any = {
        display: "flex",
        justifyContent: "space-around",
        marginTop: "3px",
        position: "relative"
    }


    function handleTemplateItemClick (event: any) {
        let clickedItem: any = event.target.innerText
        console.log(event.target.innerText)
        setDialRule((prev: any) => {
            return {...prev, returnTemplate: prev.returnTemplate + clickedItem}
        })

    }

    const clearPointStyle: any = {
        position: "absolute",
        top: "-27px",
        right: "5px",
        cursor: "pointer",
    }


    return (

        <>
            <div style={tmplItemsGridStyle}>
            {
                tmplItems.map((item: any, index: number) => {
                    return (
                        <div key={index} style={itemStyle} onClick={(event) => handleTemplateItemClick(event)}>&#123;{item}&#125;</div>
                    )
                })
            }

                {dialRule.returnTemplate &&
                    <div style={clearPointStyle}>
                        <HighlightOffIcon
                            sx={{fontSize: 14, color: '#e56679'}}
                            onClick={() => setDialRule((prev: any) => {return {...prev, returnTemplate: ''}})}
                        />
                    </div>
                }

            </div>
        </>



    )
}
